import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation  } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
// import MainLayout from '../../layouts/MainLayout';
import { GenerateWalletTxnId, GenerateOnlineTxnId } from '../../components/GenerateThink5whysCode';
import razorpaysleek from '../../assets/pageimages/razorpaysleek.webp';
import hdfcbanksleek from '../../assets/pageimages/hdfcbanksleek.webp';
// import kotakbanksleek from '../../assets/pageimages/kotakbanksleek.webp';
// import easebuzzsleek from '../../assets/pageimages/easebuzzsleek.webp';

import paymentgateways from '../../assets/pageimages/paymentgateways.webp';

const MyWalletTopup = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();
  const navigate = useNavigate();
  const location = useLocation();
  const [customerId, setCustomerId] = useState(authState.user._id); 
  const [customerCode, setCustomerCode] = useState(authState.user.think5whyscode); 
  const [customerName, setCustomerName] = useState(authState.user.name); 
  const [customerEmail, setCustomerEmail] = useState(authState.user.email); 
  const [customerPhone, setCustomerPhone] = useState(''); 

  const { title, paymentAmount, gifterId, gifterName, giftFor, giftMessage, gifterSignatureLine } = location.state || {};
// console.log("paymentAmount: ",paymentAmount);
  // State to hold the amount
  // const { paramAmount } = useParams();
  // const [amount, setAmount] = useState(paramAmount || 100); 
  const [amount, setAmount] = useState(paymentAmount ? paymentAmount: 100); 
  const [topupTitle, setTopupTitle] = useState(title ? title: 'Book'); 

  const [paymentClicked, setPaymentClicked] = useState(false);
  const [onlinePaymentClicked, setOnlinePaymentClicked] = useState(false);
  const [pgResponseData, setPgResponseData] = useState(null);
  const [pgStatus, setPgStatus] = useState(false);
  const [modePayment, setModePayment] = useState('Online');
  const [walletTransactionId, setWalletTransactionId] = useState('');
  const [transactionId, setTransactionId] = useState(GenerateOnlineTxnId());
  const [transactionDate] = useState(new Date());
  const [transactionStatus, setTransactionStatus] = useState('Initiating');
  const [paymentDetails, setPaymentDetails] = useState('');
  const [details, setDetails] = useState('Payment');
  
  const [paymentUInitiationStatus, setPaymentUInitiationStatus] = useState(false);

  useEffect(() => {
    const fetchPaymentGatewayStatus = async () => {
      try {
        const response = await fetch('/api/pgstatus'); 
        const data = await response.json();
        setPgStatus(data.paymentGatewayStatus)
        // console.log("Payment Gateway Status:", data.paymentGatewayStatus);
      } catch (error) {
        console.error("Error fetching payment gateway status:", error);
      }
    };
  
    fetchPaymentGatewayStatus();
  }, []);

  // const handleCheckPGStatus = () => {
  //   const fetchPaymentGatewayStatus = async () => {
  //     try {
  //       const response = await fetch('/api/pgstatus');
  //       const data = await response.json();
  //       setPgStatus(data.paymentGatewayStatus);
  //       console.log("Payment Gateway Status:", data.paymentGatewayStatus);
  //     } catch (error) {
  //       console.error("Error fetching payment gateway status:", error);
  //     }
  //   };
  
  //   fetchPaymentGatewayStatus();
  // };

  // const fetchPaymentGatewayStatus = async () => {
  //   try {
  //     const response = await fetch('/api/pgstatus');
  //     const data = await response.json();
  //     setPgStatus(data.paymentGatewayStatus);
  //     console.log("Payment Gateway Status:", data.paymentGatewayStatus);
  //   } catch (error) {
  //     console.error("Error fetching payment gateway status:", error);
  //   }
  // };

  // const handleCheckPGStatus = () => {
  //   fetchPaymentGatewayStatus();
  // };
  

  const handlePayment = () => {
    // handleCheckPGStatus();
    // console.log("Payment Gateway Status 2:", pgStatus);

    if (!amount) {
      alert('Please enter an amount.');
      return;
    } 
    if (amount < 1) {
      alert('Credit should not be less than 1.');
      return;
    } 
    if (amount > 5000) {
      alert('Credits should not be greater than 5000.');
      return;
    }
    if (customerPhone === '') {
      alert('Please enter mobile number.');
      return;
    } 
  
    // console.log(`Opening payment gateway for ${amount}`);
    setPaymentClicked(true);
  };

  const handleOnlinePaymentClicked = () => {
    setOnlinePaymentClicked(true);
    setWalletTransactionId(GenerateWalletTxnId());
    initiatePayment();
    // loadRazorpay();
    // handleDummyBankPayment();
  };

  const saveWalletTransaction = async (status, details) => {
    const userId = authState.user._id;
    const requestData = {
      userId,
      dateTransaction: new Date(),
      particulars: 'Recharge',
      amount,
      currency: 'Credits',
      inOut: 1,
      points: 0,
      wallet: 'User',
      remarks: 'Recharged',
      modePayment,
      walletTransactionId,
      transactionId,
      transactionDate,
      transactionStatus: status,
      paymentDetails: details,
      isActive: 1,
      isDeleted: 0,
      dateCreated: new Date(),
      createdBy: userId,
      title,
      customerName,
      customerPhone,
      customerEmail,
    };

    // console.log('Saving wallet recharge data:', requestData);
    try {
      const config = {
        url: '/wallettopup',
        method: 'post',
        data: requestData,
        headers: { Authorization: authState.token },
      };
      await fetchData(config);
    } catch (error) {
      console.error('Error saving wallet transaction:', error);
    }
  };

  const [paymentUrl, setPaymentUrl] = useState(null);

  const [pgRequestData,setPGRequestData] = useState({
    userId: customerId,
    dateTransaction: new Date(),
    particulars: 'Payment Gateway',
    amount: 0.00,
    currency: 'Credits',
    inOut: 1,
    points: 0,
    wallet: 'User Wallet',
    remarks: 'Online Payment',
    modePayment: "Online",
    walletTransactionId: '',
    transactionId: '',
    transactionDate: new Date(),
    transactionStatus: false,
    paymentDetails: details,
    isActive: 1,
    isDeleted: 0,
    dateCreated: new Date(),
    createdBy: customerId,
    title: title,
    customerName: customerName,
    customerPhone: customerPhone,
    customerEmail: customerEmail,
  });

  const sanitizeText = (text) => {
    if (!text) return ""; 
    return text.replace(/[^a-zA-Z0-9 ]/g, "").trim();
  };

  const initiatePayment = async () => {
    const userId = authState.user._id;
    const pgRequestData = {
      userId,
      dateTransaction: new Date(),
      particulars: 'Payment Gateway',
      amount,
      currency: 'Credits',
      inOut: 1,
      points: 0,
      wallet: 'User Wallet',
      remarks: 'Online Payment',
      modePayment,
      walletTransactionId,
      transactionId,
      transactionDate,
      transactionStatus: status,
      paymentDetails: details,
      isActive: 1,
      isDeleted: 0,
      dateCreated: new Date(),
      createdBy: userId,
      title: sanitizeText(title),
      customerName,
      customerPhone,
      customerEmail,
    };
  
    
    // console.log("pgRequestData: ", pgRequestData);

    try {
      const config = {
        url: "/mybooks/initpay",
        method: "post",
        data: { pgRequestData: pgRequestData, user: userId },
        headers: { Authorization: authState.token }
      };
      // console.log("Easebuzz initiate payment payload: ", config);
  
      const response = await fetchData(config);
      // console.log('Payment initiation response:', response.success);

      if (response.success) {
        // console.log('Payment initiation response:', response.data);
        // console.log('Payment URL:', response.paymentUrl);

        // Assuming response.data contains the payment URL
        setPaymentUInitiationStatus(response.success);
        setPaymentUrl(response.paymentUrl);
        setPgResponseData(response.data);

        // Determine transaction status
        const transactionCaptured = response.data.status === 'captured';
        setTransactionStatus(transactionCaptured ? 'Successful' : 'Failed');

        // Set additional payment details for UI
        setPaymentDetails(
          `Payment with ${response.data.method} via ${response.data.bank} ${
            transactionCaptured ? 'successful' : 'failed'
          }`
        );

        // Save transaction in wallet if payment is captured
        if (transactionCaptured) {
          await saveWalletTransaction('Successful', `Payment of ${amount} captured.`);
        }
      } else {
        console.error('Payment initiation failed:', response.error);
        setTransactionStatus('Failed');
        setPaymentDetails(`Payment failed: ${response.error}`);
      }
    } catch (error) {
      console.error('An error occurred during payment initiation:', error);
      setTransactionStatus('Failed');
      setPaymentDetails('Payment failed due to an unexpected error.');
    }
    };
  
  
  const handleDummyBankPayment = async () => {
    try {
      // Simulate a random payment outcome (success or failure)
      const isPaymentSuccessful = Math.random() > 0.5; // 50% chance of success or failure
  
      const dummyBankResponse = await new Promise(resolve => {
        setTimeout(() => {
          resolve({
            id: 'payment_123456789',
            status: isPaymentSuccessful ? 'captured' : 'failed', // Randomly set status
            method: 'card',
            bank: 'DummyBank',
            amount: amount,
            transactionDate: new Date(),
          });
        }, 1000);
      });
  
      setPgResponseData(dummyBankResponse);
  
      if (dummyBankResponse.status === 'captured') {
        setTransactionStatus('Successful');
        setPaymentDetails(`Paid with ${dummyBankResponse.method} via ${dummyBankResponse.bank}`);
        await saveWalletTransaction('Successful', `Payment of ${amount} captured.`);
      } else {
        setTransactionStatus('Failed');
        setPaymentDetails(`Payment with ${dummyBankResponse.method} via ${dummyBankResponse.bank} failed.`);
      }
    } catch (error) {
      console.error('An error occurred with the bank API:', error);
      setTransactionStatus('Failed');
      setPaymentDetails('Payment failed due to an unexpected error.');
    }
  };
  

  const handleCheckWallet = () => {
    navigate('/wallet-mywallet');
  };

  const handleCancel = () => {
    navigate(-1);
    // navigate('/wallet-home');
  };

  return (
  <div className="bg-black text-white [&_p]:text-white min-h-screen">
    <div className="px-4 py-6 space-y-5">
      {/* TITLE */}
      <div className="text-center space-y-2">
        <h2 className="text-sm lg:text-sm font-semibold text-yellow-200 leading-snug">
          Make Payment / Topup for Purchases on Think5Whys Platfrom
        </h2>
      </div>

      {/* MAIN CARD */}
      <div className="bg-gray-900 border border-gray-800 rounded-2xl shadow-lg p-5 max-w-lg mx-auto space-y-5">
        {/* TOPUP / BOOK SECTION */}
        {topupTitle !== 'Book' ? (
          <p className="text-yellow-200 text-center text-sm md:text-base">
            Paying {amount} for {title}
          </p>
        ) : (
          <>
            <div className="space-y-2">
              <label className="block text-white text-sm md:text-base font-medium">
                Credits
              </label>

              <input
                type="number"
                name="amount"
                id="amount"
                value={amount}
                placeholder="500"
                min="1"
                max="5000"
                step="100"
                onChange={e => setAmount(e.target.value)}
                className="w-full px-4 py-3 bg-black border border-gray-700 rounded-lg text-white focus:outline-none focus:border-blue-500"
              />
            </div>
          </>
        )}

        {/* MOBILE */}
        <div className="space-y-2">
          <label className="block text-white text-sm md:text-base font-medium">
            Mobile Number*
          </label>

          <input
            type="text"
            name="customerPhone"
            id="customerPhone"
            value={customerPhone}
            onChange={e => setCustomerPhone(e.target.value)}
            className="w-full px-4 py-3 bg-black border border-gray-700 rounded-lg text-white focus:outline-none focus:border-blue-500"
          />
        </div>

        {/* PRIMARY CTA */}
        <button
          disabled={paymentClicked}
          onClick={handleOnlinePaymentClicked}
          className="w-full bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-500 hover:to-blue-700 disabled:opacity-50 text-white font-semibold py-3 rounded-xl transition"
        >
          {topupTitle !== ''
            ? "Proceed to Pay"
            : "Add Credits Into Think5Whys Purse / Wallet / FuelStash"}
        </button>

        {/* PAYMENT INFO */}
        <div className="text-center space-y-3 text-xs md:text-sm text-gray-300">
          <p>
            You will be redirected to the payment gateway partner.
          </p>

          <img
            className="mx-auto w-20"
            id="razorpaysleek"
            src={razorpaysleek}
            alt="Payment Gateway Partner"
          />
        </div>

        {/* PAYMENT URL STATUS */}
        {paymentUInitiationStatus && (
          <div className="bg-purple-700/30 border border-purple-500 rounded-lg p-3 text-xs md:text-sm">
            <p className="text-white">
              You will be redirected to the payment gateway page.
              <a
                href={paymentUrl}
                rel="noopener noreferrer"
                className="text-yellow-200 underline mx-2"
              >
                Click here
              </a>
              to proceed.
            </p>
          </div>
        )}

        {/* BANK INFO */}
        <div className="space-y-3 text-center">
          <p className="text-yellow-200 text-xs md:text-sm">
            Upon success, your payment will go to company account in HDFC Bank (Think5Whys Global DeepTech Solution Pvt Ltd, Mumbai, India).
          </p>

          <img
            className="mx-auto w-20"
            id="hdfcbanksleek"
            src={hdfcbanksleek}
            alt="Banking Partner"
          />
        </div>

        {/* PAYMENT STATUS SECTION */}
        {paymentClicked && (
          <div className="space-y-4">
            <p className="text-white text-sm">
              Transaction Status : {transactionStatus}
            </p>
            {!pgStatus ? (
              <p className="text-yellow-200 text-xs md:text-sm">
                Currently Payment Gateway is Disabled. Please make payment through UPI to 9324342890@kotak (Sanjeev Kumar)
              </p>
            ) : (
              <p className="text-yellow-200 text-xs md:text-sm">
                You will make payment to HDFC Bank account via FinTech Partner(s).
              </p>
            )}
            <button
              type="button"
              className="w-full bg-green-700 hover:bg-green-800 text-white py-3 rounded-xl font-medium"
              onClick={handleOnlinePaymentClicked}
              disabled={!pgStatus}
            >
              Proceed to Pay (Through FinTech Partner)
            </button>

            {/* PAYMENT STATUS RESULT */}
            {onlinePaymentClicked && (
              <div className="p-4 border border-gray-700 bg-gray-900 rounded-xl space-y-2">

                {transactionStatus === 'Successful' && (
                  <>
                    <p className="text-green-400 font-semibold">
                      Payment Successful!
                    </p>
                    <p className="text-gray-300 text-sm">
                      Transaction ID: {transactionId}
                    </p>
                    <p className="text-gray-300 text-sm">
                      Credits: {amount}
                    </p>
                    <p className="text-gray-300 text-sm">
                      Payment Date: {transactionDate.toLocaleString()}
                    </p>
                  </>
                )}

                {transactionStatus === 'Failed' && (
                  <>
                    <p className="text-red-400 font-semibold">
                      Payment Failed. Please try again.
                    </p>

                    <button
                      type="button"
                      className="w-full bg-red-600 hover:bg-red-700 text-white py-3 rounded-xl font-medium"
                      onClick={handleOnlinePaymentClicked}
                    >
                      Retry Payment
                    </button>
                  </>
                )}

                <button
                  type="button"
                  className="w-full bg-green-700 hover:bg-green-800 text-white py-3 rounded-xl font-medium"
                  onClick={handleCheckWallet}
                >
                  Check Think5Whys Purse / Wallet
                </button>

                <img
                  className="mx-auto w-40 mt-3"
                  id="paymentgateways"
                  src={paymentgateways}
                  alt="Payment Gateways"
                />
              </div>
            )}
          </div>
        )}

        {/* FOOTER CTA */}
        <button
          onClick={handleCancel}
          className="w-full bg-gray-800 hover:bg-gray-700 text-white font-semibold py-3 rounded-xl transition border border-gray-700"
        >
          Back
        </button>

      </div>
    </div>
  </div>
);
};

export default MyWalletTopup;
